import Api from '@/api/api'

export default {
    getTenant() {
        return Api.get('Org/tenant/GetTenantByID');
    },
    updateTenant(id, name, data) {
        return Api.put('Org/tenant/UpdateTenantLogo?ID=' + id + '&displayName=' + name + '&referencetype=tenant', data);
    },
    getTenantEmpDetails() {
        return Api.get('Org/Employee');
    },
    getEmpFromCurrentUser() {
        return Api.get('Employee/GetEmployeeFromCurrentUser');
    },
    geOrgDetails(tenantID, faceID) {
        return Api.get(`SaasAdmin/api/Configuration/SettingsByGroup?tenantID=${tenantID}&facilityID=${faceID}&groups=org`);
    },
    fileupload(tenantID,type,body){
        return Api.post(`FileUpload/api/FileUpload/UploadImage?referenceID=${tenantID}&referenceType=${type}`,body)
    },
    updateFile(url,name){
        return Api.put(`Org/Tenant/UpdateTenantLogo?logoURL=${url}&displayName=${name}`)
    },
    updateProfileImage(body){
        return Api.put(`ETMSAgr/Employee/SetProfilePic`,body)
    },
    getTenantSettings(tenantId) {
        return Api.get(`/api/TenantSettings/GetAllTenantSettingsByGroup?tenantId=${tenantId}&groups=settings`);
    },
    addTenantSettings(){
        return Api.post('api/TenantSettings/AddTenantSettings')
    },
    updateTenantSettings(body){
        return Api.put('/api/TenantSettings/UpdateTenantSettings',body);
    }
}